import React from 'react';
import { Box, Text, VStack, HStack, Icon, useColorModeValue } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { RiMailSendLine } from 'react-icons/ri';
import { FaBrain } from 'react-icons/fa';

const MotionBox = motion(Box);

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 }
  }
};

export const StatBox = ({ input, output, delay = 0 }) => {
  return (
    <MotionBox
      variants={itemVariants}
      initial="hidden"
      animate="visible"
      transition={{ delay }}
    >
      <Box
        p={6}
        borderRadius="xl"
        bg={useColorModeValue('white', 'gray.800')}
        shadow="xl"
        position="relative"
        _hover={{
          transform: 'scale(1.02)',
          shadow: '2xl',
          transition: 'all 0.3s ease'
        }}
      >
        <VStack align="start" spacing={4}>
          <Box>
            <HStack mb={2}>
              <Icon as={RiMailSendLine} color="gray.500" />
              <Text fontWeight="bold">You write:</Text>
            </HStack>
            <Text color="gray.600" fontSize="md">{input}</Text>
          </Box>
          <Box w="full">
            <HStack mb={2}>
              <Icon as={FaBrain} color="blue.500" />
              <Text fontWeight="bold">AI responds:</Text>
            </HStack>
            <Text color="blue.600" fontSize="md">{output}</Text>
          </Box>
        </VStack>
      </Box>
    </MotionBox>
  );
};
